import React from 'react';

import Box from '@mui/material/Box';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';

const ColorPicker = ({ label, value, onChange, name, sx = {}, allowTransparent = false, ...props }) => {
	const [anchorEl, setAnchorEl] = React.useState(null);

	const colors = ['#1abc9c', '#2ecc71', '#3498db', '#9b59b6', 
		'#16a085', '#27ae60', '#2980b9', '#8e44ad', 
		'#34495e', '#f1c40f', '#e67e22', '#e74c3c', 
		'#2c3e50', '#f39c12', '#d35400', '#c0392b',
		...(allowTransparent ? ['transparent', '#ffffff'] : ['#ffffff', '#bdc3c7']), '#95a5a6', '#7f8c8d',
	];

	const colorWidth = 80;
	const colorHeight = 60;
	const paletteWidth = 80 * 4;

	const handleColor = c => {
		setAnchorEl(null);
		onChange({ target: { name, value: c }});
	};

	const handleManualColor = e => {
		const v = e.target.value.replace('#', '');
		onChange({ target: { name, value: v ? '#' + v : null }});
	};

	return (<>
		<TextField
			fullWidth
			sx={{ ...sx, '& .MuiInputBase-root': { backgroundColor: value || 'transparent' }, '& .MuiInputBase-root:hover': { pointer: 'crosshair'} }}
			onClick={e => { e.preventDefault; setAnchorEl(e.currentTarget); }}
			InputProps={{ readOnly: true }}
			label={label}
			{...props}
		/> 
		<Menu
			anchorEl={anchorEl}
			open={!!anchorEl}
			onClose={() => setAnchorEl(null)}
			sx={{ '& .MuiList-root': { padding: 0 } }}
		>
			<Box sx={{ 
				width: paletteWidth, 
				display: 'flex', 
				flexDirection: 'row', 
				flexWrap: 'wrap', 
			}}>
				{colors.map(c => 
					<MenuItem 
						key={c} 
						sx={{ 
							width: colorWidth, 
							height: colorHeight, 
							backgroundColor: c === 'transparent' ? 'transparent' : c,
							...(c === 'transparent' && {
								border: '1px solid #ccc',
								backgroundImage: 'linear-gradient(45deg, #ccc 25%, transparent 25%), linear-gradient(-45deg, #ccc 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #ccc 75%), linear-gradient(-45deg, transparent 75%, #ccc 75%)',
								backgroundSize: '20px 20px',
								backgroundPosition: '0 0, 0 10px, 10px -10px, -10px 0px',
							}),
						}} 
						onClick={() => handleColor(c === 'transparent' ? null : c)}
					>
						&nbsp;
					</MenuItem>)}
			</Box>
			<TextField 
				value={value?.replace('#', '')} 
				fullWidth 
				onChange={handleManualColor}
				variant='standard'
				InputProps={{
					startAdornment: <InputAdornment position="start">#</InputAdornment>,
					disableUnderline: true,
					sx:{ padding: 2 },
				}}
			/>
		</Menu>
	</>
	);
};

ColorPicker.type = 'ColorPicker';

export default ColorPicker;